import React, { useState, useEffect, useRef } from "react";
import Button from "utils/Button";
import GetAny from "utils/GetAny";
import WorkTwoColumnCardsItems from "./WorkTwoColumnCardsItems";

let arrayForHoldingPosts = []

const WorkTwoColumnCards = ({blok}) => {
    const posts = GetAny([], 'work')

    let initialPosts = 16
    const postsPerLoad = 4
    const [postsToShow, setPostsToShow] = useState([])
    const ref = useRef(initialPosts)

    const loopWithSlice = (start, end) => {
        const slicedPosts = posts.slice(start, end)
        arrayForHoldingPosts = arrayForHoldingPosts.concat(slicedPosts)
        arrayForHoldingPosts = [...new Set(arrayForHoldingPosts)];
        setPostsToShow(arrayForHoldingPosts)
    }

    const handleShowMorePosts = () => {
        loopWithSlice(ref.current, ref.current + postsPerLoad)
        ref.current += postsPerLoad
    }

    useEffect(() => {
        loopWithSlice(0, initialPosts)
    }, [])



    return (
        <div className="relative overflow-hidden my-60">
            <WorkTwoColumnCardsItems postsToRender={postsToShow}/>
            <div className="px-6 lg:px-12 px-6 lg:py-12 md:py-8 py-6 max-w-7xl mx-auto">
                {(ref.current < posts.length) && (initialPosts < posts.length) &&
                    <Button onClick={handleShowMorePosts}>Show more</Button>
                }
            </div>
        </div>
    );
};

export default WorkTwoColumnCards;
